import CopyTextWrapper from 'components/others/CopyTextWrapper';

interface GenerationLogEmailCellProps {
    sentToEmail?: number | boolean;
    sentEmail?: string;
    notSentLabel: string;
    sentNoEmailLabel: string;
    sendTitle: string;
    disabled?: boolean;
    onSend?: () => void;
}

const parseSentEmails = (value?: string): string[] =>
    String(value || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

const GenerationLogEmailCell = ({
    sentToEmail,
    sentEmail,
    notSentLabel,
    sentNoEmailLabel,
    sendTitle,
    disabled = false,
    onSend,
}: GenerationLogEmailCellProps) => {
    const sendButton = onSend ? (
        <button
            type="button"
            className="btn btn-link proposal-send-email-btn"
            disabled={disabled}
            onClick={onSend}
        >
            {sendTitle}
        </button>
    ) : null;

    if (sentToEmail) {
        const emails = parseSentEmails(sentEmail);

        return (
            <div className="email-cell-content">
                {emails.length ? (
                    <div className="email-list">
                        {emails.map((email, index) => (
                            <CopyTextWrapper key={`${email}-${index}`} value={email}>
                                <span className="email-value" title={email}>
                                    {email}
                                </span>
                            </CopyTextWrapper>
                        ))}
                    </div>
                ) : (
                    <span className="text-muted">{sentNoEmailLabel}</span>
                )}
                {sendButton}
            </div>
        );
    }

    if (!onSend) {
        return <span className="text-muted">{notSentLabel}</span>;
    }

    return sendButton;
};

export default GenerationLogEmailCell;
